module.exports = __webpack_public_path__ + "img/public-logo.591d7ea2.svg";